// jest测试环境需要模拟web环境进行测试，因此不能通过process属性判定node环境，这会导致jest模拟的web环境测试
export function isServer() {
  return typeof document === 'undefined';
}